import type { ScrollWorldConfig } from './scroll-world';

export const siteConfig: ScrollWorldConfig = {
  brand: {
    name: 'HackStacks',
    href: '#top',
    mark: '/assets/brand/hackstacks-monogram.svg',
  },
  primaryCta: {
    label: 'Begin the inquiry',
    href: '#inquiry',
  },
  hint: 'Scroll to advance',
  masterMedia: {
    clip: '/assets/video/hackstacks-journey-hq.mp4',
    mobileClip: '/assets/video/hackstacks-journey-hq.mp4',
    webmClip: '/assets/video/hackstacks-journey-hq-vp9.webm',
    mobileWebmClip: '/assets/video/hackstacks-journey-hq-vp9.webm',
    poster: '/assets/video/hackstacks-journey-poster.jpg',
  },
  sceneUnits: 1.45,
  connectorUnits: 0.85,
  crossfadeUnits: 0.16,
  handoffUnits: 0.75,
  seekSmoothing: 1,
  scenes: [
    {
      id: 'proposition',
      label: 'Proposition',
      still: '/assets/scenes/01-clarity.svg',
      accent: '#c9a66b',
      title: 'Your product has its own laws.',
      body: 'We assemble the thinking, craft, and technology required to turn a singular idea into a precise working system.',
      tags: ['Strategy', 'Design', 'Engineering', 'Beyond'],
      scrollUnits: 1.7,
      linger: 0.4,
    },
    {
      id: 'system',
      label: 'System',
      still: '/assets/scenes/02-team.svg',
      accent: '#8fa2b9',
      title: 'Understand before building.',
      body: 'We map the actors, constraints, risks, and feedback loops—then challenge every assumption that cannot survive evidence.',
      tags: ['Empirical decisions', 'System architecture', 'Product strategy'],
      linger: 0.32,
    },
    {
      id: 'team',
      label: 'Team',
      still: '/assets/scenes/03-build.svg',
      accent: '#e5c98f',
      title: 'The system chooses the team.',
      body: 'A three-founder core assembles the right disciplines from a network of around 200 specialists and remains accountable for the whole.',
      tags: ['Accountable core', 'Flexible scale', 'Agency-ready'],
      linger: 0.28,
    },
    {
      id: 'construction',
      label: 'Construction',
      still: '/assets/scenes/04-scale.svg',
      accent: '#8fa2b9',
      title: 'Every discipline, one entity.',
      body: 'We combine whatever the product requires without dividing its logic into a conveyor belt.',
      tags: ['Designed as one', 'Built to evolve', 'Supported beyond launch'],
      linger: 0.34,
    },
    {
      id: 'beginning',
      label: 'Begin',
      still: '/assets/scenes/05-contact.svg',
      accent: '#c9a66b',
      title: 'Bring us the idea. Or the hard part.',
      body: 'Tell us what exists, what must become possible, and what a rational result looks like.',
      tags: [],
      scrollUnits: 1.7,
      linger: 0.42,
      cta: {
        primary: {
          label: 'Start the inquiry',
          href: '#inquiry',
        },
        secondary: {
          label: 'Back to the start',
          href: '#top',
        },
      },
    },
  ],
  connectors: [],
  mobileConnectors: [],
};
